import axios from "axios";

const state = {
  rsvp: false
};

const mutations = {
  guestsCreated: state => {
    state.rsvp = true;
  }
};

const actions = {
  newGuests: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let CONFIG = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
      let numberOfGuests = payload.length;
      for (var guest = 0; guest < numberOfGuests; guest++) {
        let guestDetails = payload[guest];
        const form = new FormData();
        form.set("name", guestDetails.name);
        form.set("kidsMeal", guestDetails.kidsMeal);
        form.set("allergies", guestDetails.allergies);
        form.set("mainCourse", guestDetails.mainCourse);
        form.set("dessert", guestDetails.dessert);
        let URL = "https://hooks.zapier.com/hooks/catch/10469746/b38aiv6/";
        axios
          .post(URL, form, CONFIG)
          .then(response => response.data)
          .then(guests => {
            commit("guestsCreated", guests);
          })
          .catch(errors => {
            reject(errors);
          });
      }
    });
  }
};

const getters = {
  rsvp(state) {
    return state.rsvp;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
